import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: 86,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 12px 10px',
    boxSizing: 'border-box',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  },
  link: {
    width: '100%',
    minWidth: sidebarConfig.drawerWidthClosed,
    minHeight: 58,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    background:
      'linear-gradient(135deg, rgba(255,255,255,0.05), rgba(110,231,220,0.025))',
    transition: 'background 160ms ease, transform 160ms ease',
    '&:hover': {
      background:
        'linear-gradient(135deg, rgba(255,255,255,0.08), rgba(110,231,220,0.06))',
      transform: 'translateY(-1px)',
      textDecoration: 'none',
    },
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link
        to="/"
        underline="none"
        className={classes.link}
        aria-label="ARANOX Platform"
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
